import * as TWEEN from '@tweenjs/tween.js'

export const ease = prop => new TWEEN.Tween(prop)
export const Easing = TWEEN.Easing
export const easeUpdate = time => TWEEN.update(time)

const BLUR = '30'

export const easeInWord = function (word, onComplete = () => {}, list = null, duration = 1500) {
  const updateTranslate = ratio => `translate3d(0, ${(1 - ratio) * 60}px, 0)`
  // const updateBlur = ratio => `blur(${(1 - ratio) * 5}px)`
  // const updateTextShadow = ratio => `0px 0px ${BLUR}px rgba(255, 255, 255, ${(1 - ratio * 1.2)})`
  const delay = Math.random() * 500
  const transform = getComputedStyle(word).transform
  word.style.opacity = 0
  ease(word.style)
  .to({opacity: 1}, duration)
  .onUpdate(o => {
    word.style.transform = `${updateTranslate(o.opacity)} ${transform !== 'none' ? transform : ''}`
    // word.style.filter = updateBlur(o.opacity)
    // word.style.textShadow = updateTextShadow(o.opacity)
  })
  .onComplete(() => typeof(onComplete) === 'function' ? onComplete(): null)
  .easing(Easing.Cubic.Out)
  .delay(delay)
  .start()
}

export const easeOutWord = function (word, onComplete = () => {}, list = null, duration = 1000) {
  const updateTranslate = ratio => `translate3d(0, -${(1 - ratio) * 40}px, 0)`
  // const updateBlur = ratio => `blur(${(1 - ratio) * 5}px)`
  const updateTextShadow = ratio => `0px 0px ${BLUR}px rgba(255, 255, 255, ${(1 - ratio * 1.2)})`
  const delay = Math.random() * 500
  const transform = getComputedStyle(word).transform
  word.style.opacity = 1
  ease(word.style)
  .to({opacity: 0}, duration)
  .onUpdate(o => {
    word.style.transform = updateTranslate(o.opacity) + ' ' + transform
    //word.style.filter = updateBlur(o.opacity)
    word.style.textShadow = updateTextShadow(o.opacity)
  })
  .onComplete(() => typeof(onComplete) === 'function' ? onComplete(): null)
  .easing(Easing.Cubic.In)
  .delay(delay)
  .start()
}


// WEBPACK FOOTER //
// ./src/scripts/helpers/EaseHelper.js